import {ProjectStatus, Right, TeamRole} from "../interfaces";

interface authConfigGroup {
    status?: ProjectStatus[],
    notStatus?: ProjectStatus[],
    rights?: Right[],
    roles?: TeamRole[],
    creator?: boolean;
}

interface authConfigElement {
    ID: string;
    groups: authConfigGroup[],
}

export const authConfig: authConfigElement[] = [
    // NAVIGATION
    {
        ID: "NAVIGATION_SHOW_OTHERS",
        groups: [
            {
                notStatus: [ProjectStatus.CREATED, ProjectStatus.DECLINED, ProjectStatus.LINE],
            },
        ]
    },
    {
        ID: "NAVIGATION_SHOW_REPORTING",
        groups: [
            {
                status: [ProjectStatus.RELEASED, ProjectStatus.IN_PROGRESS, ProjectStatus.COMPLETION_FILED, ProjectStatus.COMPLETED]
            },
        ]
    },
    {
        ID: "NAVIGATION_SHOW_COMPLETION",
        groups: [
            {
                status: [ProjectStatus.COMPLETION_FILED, ProjectStatus.COMPLETED]
            },
        ]
    },
    {
        ID: "NAVIGATION_SHOW_EXTERNAL",
        groups: [
            {
                status: [ProjectStatus.RELEASED, ProjectStatus.IN_PROGRESS, ProjectStatus.COMPLETION_FILED, ProjectStatus.COMPLETED]
            },
        ]
    },
    {
        ID: "NAVIGATION_SHOW_APPROVALS",
        groups: [
            {
                notStatus: [ProjectStatus.CREATED, ProjectStatus.DECLINED, ProjectStatus.LINE, ProjectStatus.IN_ELABORATION]
            },
        ]
    },

    // PROJECT
    {
        ID: "PROJECT_DELETE",
        groups: [
            {
                rights: [Right.DELETE_PROJECT],
            },
        ]
    },
    {
        ID: "PROJECT_SET_DECLINED",
        groups: [
            {
                status: [ProjectStatus.CREATED],
                rights: [Right.PMO, Right.CEO],
            },
        ]
    },
    {
        ID: "PROJECT_SET_LINE",
        groups: [
            {
                status: [ProjectStatus.CREATED],
                rights: [Right.PMO, Right.CEO],
            },
        ]
    },
    {
        ID: "PROJECT_SET_IN_ELABORATION",
        groups: [
            {
                status: [ProjectStatus.CREATED],
                rights: [Right.PMO, Right.CEO],
            },
        ]
    },
    {
        ID: "PROJECT_SET_EVALUATION",
        groups: [
            {
                status: [ProjectStatus.IN_ELABORATION],
                roles: [TeamRole.Lead, TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.IN_ELABORATION],
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "PROJECT_SET_CANCELLED",
        groups: [
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "PROJECT_SET_REVISE",
        groups: [
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "PROJECT_SET_RELEASED",
        groups: [
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "PROJECT_SET_COMPLETION_FILED",
        groups: [
            {
                status: [ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Lead],
            },
            {
                status: [ProjectStatus.IN_PROGRESS],
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "PROJECT_SET_COMPLETED",
        groups: [
            {
                status: [ProjectStatus.COMPLETION_FILED],
                rights: [Right.PMO],
            },
            {
                status: [ProjectStatus.COMPLETION_FILED],
                roles: [TeamRole.Orderer],
            },
        ]
    },
    {
        ID: "PROJECT_TOGGLE_ON_HOLD",
        groups: [
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "PROJECT_SHOW_APPROVAL_PROJECT",
        groups: [
            {
                status: [ProjectStatus.REVISE, ProjectStatus.EVALUATION, ProjectStatus.RELEASED, ProjectStatus.IN_PROGRESS, ProjectStatus.COMPLETION_FILED, ProjectStatus.COMPLETED],
            },
        ]
    },
    {
        ID: "PROJECT_SHOW_APPROVAL_COMPLETION",
        groups: [
            {
                status: [ProjectStatus.IN_PROGRESS, ProjectStatus.COMPLETION_FILED, ProjectStatus.COMPLETED],
            },
        ]
    },

    {
        ID: "PROJECT_MIGRATE",
        groups: [
            {
                rights: [Right.MIGRATE_PROJECT],
            },
        ]
    },

    // EDIT TABS
    {
        ID: "EDIT_IDEA",
        groups: [
            {
                status: [ProjectStatus.CREATED],
                creator: true,
            },
            {
                status: [ProjectStatus.CREATED],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_GOALS",
        groups: [
            {
                status: [ProjectStatus.IN_ELABORATION, ProjectStatus.REVISE],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Lead],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_ORGANISATION",
        groups: [
            {
                status: [ProjectStatus.IN_ELABORATION, ProjectStatus.REVISE],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Lead],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_COSTS",
        groups: [
            {
                status: [ProjectStatus.IN_ELABORATION, ProjectStatus.REVISE],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Lead],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "APPROVE_BUDGET",
        groups: [
            {
                status: [ProjectStatus.EVALUATION, ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Orderer],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "ADD_BUDGET",
        groups: [
            {
                status: [ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Lead],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_DATES",
        groups: [
            {
                status: [ProjectStatus.IN_ELABORATION, ProjectStatus.REVISE],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.RELEASED],
                roles: [TeamRole.Orderer, TeamRole.Lead],
            },
            {
                status: [ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Lead],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_RISKS",
        groups: [
            {
                status: [ProjectStatus.IN_ELABORATION, ProjectStatus.REVISE],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.RELEASED],
                roles: [TeamRole.Orderer, TeamRole.Lead],
            },
            {
                status: [ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_STAKEHOLDER",
        groups: [
            {
                status: [ProjectStatus.IN_ELABORATION, ProjectStatus.REVISE],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.RELEASED],
                roles: [TeamRole.Orderer, TeamRole.Lead],
            },
            {
                status: [ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_REPORTING",
        groups: [
            {
                status: [ProjectStatus.RELEASED, ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Lead],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_COMPLETION",
        groups: [
            {
                status: [ProjectStatus.IN_PROGRESS], // Projektabschluss aktiv
                roles: [TeamRole.Lead],
            },
            {
                status: [ProjectStatus.COMPLETION_FILED],
                roles: [TeamRole.Orderer, TeamRole.Lead, TeamRole.Customer],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_DOCUMENTS",
        groups: [
            {
                status: [ProjectStatus.IN_ELABORATION, ProjectStatus.REVISE, ProjectStatus.EVALUATION, ProjectStatus.RELEASED, ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.IN_ELABORATION, ProjectStatus.REVISE, ProjectStatus.RELEASED, ProjectStatus.IN_PROGRESS],
                roles: [TeamRole.Lead, TeamRole.Customer],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_APPROVALS",
        groups: [
            {
                status: [ProjectStatus.EVALUATION],
                roles: [TeamRole.Lead, TeamRole.Customer, TeamRole.Orderer],
            },
            {
                status: [ProjectStatus.COMPLETION_FILED],
                roles: [TeamRole.Customer, TeamRole.Orderer],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_EXTERNAL",
        groups: [
            {
                status: [ProjectStatus.RELEASED, ProjectStatus.IN_PROGRESS],
                rights: [Right.FINANCE, Right.IT],
            },
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_FEEDBACK",
        groups: [
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "RELOAD",
        groups: [
            {
                rights: [Right.PMO],
            },
        ]
    },
    {
        ID: "EDIT_TEMPLATES",
        groups: [
            {
                rights: [Right.PMO],
            },
        ]
    },
]
